import { AxiosPromise } from 'axios';
import Http from '../../shared/http';

const http = Http.getHttp();

export default function exportWiretaps(
  id: number,
  body: string
): AxiosPromise<BlobPart> {
  return http.post(`/wiretaps/${id}/export?${body}&$view=reporting`, {
    responseType: 'blob'
  });
}
